/**
 * Templates para Send Custom Email & Notification
 * Placeholders: {{user_name}}, {{amount}}, {{txn_id}}, {{request_type}}, {{request_status_label}}
 * A assinatura FIDDUX é adicionada automaticamente pelo backend (clientEmailTemplate)
 */

export const EMAIL_TEMPLATES = [
  {
    id: 'none',
    label: '— Sem template —',
    subject: '',
    body: '',
    notification_title: '',
    notification_body: ''
  },
  {
    id: 'review_withdrawal_redotpay',
    label: 'Review Withdrawal to RedotPay',
    subject: '[Automatic Alert] Risk Review of Your Withdrawal to RedotPay (ID-{{txn_id}})',
    body: `<p>This is an automated notification generated by our FIDDUX monitoring system. Our systems have detected that your withdrawal request of {{amount}} (ID-{{txn_id}}) was directed to an address associated with RedotPay.</p>
<p>Based on prior instances involving other clients utilising RedotPay for similar amounts in a single transaction, they are more likely to be subject to review by the recipient platform, which may result in the temporary withholding of funds for durations ranging from <em>3 to 14 days</em>, depending on the recipient's company's internal compliance policies.</p>
<p>Consequently, our system has flagged this withdrawal with an <em>operational risk indicator</em> and strongly recommends:</p>
<ol>
<li>That you <em>cancel this current request directly through the FIDDUX application</em>.</li>
<li>When you choose to proceed, <em>submit new withdrawal requests for smaller amounts separately</em>, exclusively via the application.</li>
</ol>
<p>We emphasize that there is currently no regulatory restriction imposed by FIDDUX; this measure is implemented to minimize the likelihood of encountering prolonged and unexpected delays in the release of funds on the destination platform.</p>
<p>All related actions regarding this withdrawal (cancellation and new requests) must be conducted directly through the FIDDUX application at your convenience.</p>
<p>Sincerely,<br>Automated Monitoring System</p>`,
    notification_title: 'Risk Review – Withdrawal to RedotPay',
    notification_body: 'Your withdrawal was flagged for operational risk. Please check your email for details and next steps.'
  }
];
